import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { fields } from '../../common/lib/redux-fields'
import { validateTestSignUp } from '../../common/auth/validations'
import { signUp, testSignUp } from '../../common/users/actions'
import formValidation from '../../common/lib/formValidation'
import { Button, TextInput } from '../components'
import { roles } from '../../common/config'


class TestSignUpForm extends React.Component {
  componentWillUnmount() {
    const { fields } = this.props
    fields.$reset()
  }

  async submitForm(e) {
    const { fields, submit, testSignUp } = this.props
    e.preventDefault()
    const values = fields.$values()

    const data = {
      ...values,
      testSignUp: true,
      name: values.name && values.name.trim(),
      email: values.email && values.email.trim(),
    }

    if (await submit(data) !== false) {
      fields.$reset()
    }
  }

  render() {
    const { fields, errorMessage, intl } = this.props
    
    return (
      <div>
        <TextInput
          {...fields.email}
          placeholder={intl.formatMessage(messages.enterEmail)}
        />
        <TextInput
          {...fields.password}
          type="password"
          placeholder={intl.formatMessage(messages.enterPassword)}
        />
        {errorMessage}
        <Button
          positive
          onClick={e => this.submitForm(e)}
        >
          {intl.formatMessage(messages.continue)}
        </Button>
      </div>
    )
  }
}

TestSignUpForm.defaultProps = {
  currentLesson: null,
  currentTest: null,
}

TestSignUpForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
  currentLesson: PropTypes.object,
  currentTest: PropTypes.object,
  submit: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(state => ({
    currentTest: state.tests.currentTest,
  }), { signUp, testSignUp }),
  formValidation((props) => ({
    validationFunc: validateTestSignUp,
    submitFunc: props.testSignUp,
  })),
  fields({
    path: 'TestSignUpForm',
    fields: [
      'email',
      'password',
    ],
    getInitialState: () => ({
      email: '',
      password: '',
    }),
  }),
  injectIntl,
)

export default enhance(TestSignUpForm)

const messages = defineMessages({
  enterEmail: {
    id: 'signUp.form.enterEmail',
    defaultMessage: 'Zadajte Váš email',
  },
  enterPassword: {
    id: 'signUp.form.enterPassword',
    defaultMessage: 'Zadajte Vaše heslo',
  },
  continue: {
    id: 'signUp.form.continue',
    defaultMessage: 'Pokračovať',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/TestSignUpForm.js